import React from "react";
import { OrganizationDataRecipientDto } from "../../../../../../common/service/server/dto/OrganizationDataRecipientDto";
import { DataRecipientLogo } from "../../../../DataRecipientLogo";
import "./shared-styles.css";

/**
 * The read-only list of data recipients nested under a manager row, shown in the Delete, Opt-Out and Access steps.
 * Nested recipients are handled by their manager (an ad-network manager, or TrueVault Connected System), so they get
 * no outcome controls of their own.
 */
export const NestedVendorList = ({
  managerName,
  nestedVendors,
  title,
}: {
  managerName: string;
  nestedVendors: OrganizationDataRecipientDto[];
  /** Overrides the default "Vendors managed by ..." heading. */
  title?: string;
}) => {
  if (!nestedVendors?.length) {
    return null;
  }

  return (
    <div className="pl-xs">
      <div className="text-weight-bold mt-lg text-t1">
        {title ?? `Vendors managed by ${managerName}:`}
      </div>
      {nestedVendors.map((nested) => (
        <div
          className="d-flex flex--align-center mt-md pl-xs text-t1 managed-vendor-item"
          key={nested.id}
        >
          <DataRecipientLogo dataRecipient={nested} size={32} />
          <span> {nested.name} </span>
        </div>
      ))}
    </div>
  );
};
